module.exports = __webpack_public_path__ + "static/img/whdx.d424fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whdx.png
// module id = AYCS
// module chunks = 0